import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { UpgradePackRequest } from '../api/tune/upgradepack/upgradepackrequest';
import { UpgradePackResponse, UpgradePackResponseDtoImpl } from '../api/tune/upgradepack/upgradepackresponse';
import { APIProcessorImpl } from './apiProcessor';

export class UpgradePackNonLoggedInAPIProcessorImpl extends APIProcessorImpl<UpgradePackRequest, UpgradePackResponse>
{
    execute(request: UpgradePackRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            console.log("----------success");

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new UpgradePackResponseDtoImpl(APIFeatures.UPGRADE_PACK, 
                    this.getContext().getResources().getString(Strings.your_order_is_successfully_completed));
                   
                this.getAPISuccess(response);
               
              
            }
        }
        catch (e) {
            
            this.getAPIFailure(new UpgradePackResponseDtoImpl(APIFeatures.UPGRADE_PACK, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
  
        this.getAPIFailure(new UpgradePackResponseDtoImpl(APIFeatures.UPGRADE_PACK, responseMapper.getStatusMsg()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/upgradepacknonloggedinapiprocessor.tsx